// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonListListResultModel from '../../model/lecture-lesson-list-list-result-model';
import LectureLessonListListResultDTO from '../dto/lecture-lesson-list-list-result-dto';
import dtoSchema from '../schemas/lecture-lesson-list-list-result-schema';
import LectureLessonListModel from '../../model/lecture-lesson-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class LectureLessonListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LectureLessonListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: LectureLessonListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<LectureLessonListListResultDTO>): LectureLessonListListResultModel;
  static toModel(dto: DeepPartial<LectureLessonListListResultDTO> | undefined | null): LectureLessonListListResultModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonListListResultDTO> | undefined | null): LectureLessonListListResultModel | undefined {
    return dto ? new LectureLessonListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonListListResultModel> | LectureLessonListListResultModel): LectureLessonListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as LectureLessonListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonListListResultModel, can not map to LectureLessonListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
